const dataExport = {
  export: 'Exportar',
  errorMessage: 'La exportación de datos encontró errores inesperados.',
  waitForDownloadMessage: 'Solicitud enviada, tu descarga comenzará en breve.',
  exportToCsv: {
    title: 'Exportar CSV',
    body: 'Estás a punto de exportar un archivo CSV para {{selectedCount}} {{itemsLabel}}.',
  },
};

export default dataExport;
